import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UserInfoResponse } from 'lib-base';

@Injectable({
  providedIn: 'root'
})
export class AdminAuthService {
  private readonly baseUrl = `${environment.apiUrl}/api/auth`;

  constructor(private readonly http: HttpClient) { }

  getUserInfo(): Observable<UserInfoResponse> {
    return this.http.get<UserInfoResponse>(`${this.baseUrl}/user-info`);
  }
}
